/** publish: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "leaveOut": "Leave it out",
  "leftOut": "Taken off {name}",
  "moreWarnings": "(and {n} more like it) | (and {n} more like it) | (and {n} more like it)",
  "nOnline": "{n} online",
  "nOffline": "{n} offline",
  "titleTarget": "Add to the play queue · {name}",
  "titleOne": "Publish “{name}”",
  "titleMany": "Publish {n} items",
  "alreadyInList": "Already in this list",
  "alreadyOnPlayer": "Already on this player",
  "alreadyInGroup": "Already in this group",
  "onAllTargets": "Already on all of them",
  "onNOfM": "On {n} of {m}",
  "skipped": " · {n} already there, skipped",
  "publishedTo": "Published to {players}{skipped}",
  "nothingNew": "Nothing new to publish{skipped}",
  "nPlayers": "{n} player | {n} players",
  "more": "+{n} more",
  "searchContent": "Search content",
  "searchTargets": "Search players, player groups, tags",
  "search": "Search",
  "loading": "Loading…",
  "allPlayers": "Publish on all Players",
  "groups": "Groups",
  "nSelected": "{n} selected",
  "playOrder": "Play order",
  "playOrderHint": "They play in this order, one after another. Drag a row, or use ↑ ↓, to change it.",
  "dragOrder": "Reorder {name}, number {n}: drag, or Alt+↑ / Alt+↓",
  "dragOrderTip": "Drag to reorder",
  "playsNth": "Plays {n}",
  "moveUp": "Move {name} up",
  "moveDown": "Move {name} down",
  "unpick": "Remove {name} from the selection",
  "noGroups": "No player groups.",
  "tags": "Tags",
  "addTag": "+ Add a tag",
  "addTagSr": "Add a tag",
  "tagsHint": "Content will be published to all players and player groups that have these tags — also ones tagged later.",
  "where": "Where in the list",
  "atEnd": "At the end",
  "atStart": "At the start",
  "atEndHint": "Plays after what's already there",
  "atStartHint": "Plays first, before the rest",
  "reach": "→ {players}",
  "plusFuture": " now (+ future tagged)",
  "cancel": "Cancel",
  "publishing": "Publishing…",
  "publish": "Publish",
  "tAll": "All",
  "tPlaylists": "Playlists",
  "tCampaigns": "Campaigns",
  "tApps": "Apps",
  "tVideos": "Videos",
  "tImages": "Images",
  "contentType": "Content type",
  "clear": "Clear",
  "nothingMatches": "Nothing matches.",
  "newContent": "New",
  "newUpload": "Upload files",
  "newUploadHint": "Added here and ticked when ready",
  "newWebPage": "Web page",
  "newApp": "App (clock, weather, ticker…)",
  "newComposition": "Composition",
  "readyPublishQ": "“{name}” is ready",
  "createdPublishQ": "“{name}” saved",
  "publishNow": "Publish now",
  "newPlaylist": "Playlist",
  "newCampaign": "Campaign",
  "newEditorHint": "Opens the editor, then comes back here",
  "uploadingN": "Uploading {n}…",
  "optimizing": "Optimizing… {p}",
  "waitUploads": "Waiting for uploads to finish",
  "uploadFailed": "Upload failed: {error}",
  "intentBanner": "Creating for “{name}”: save it to come back and publish",
  "showMore": "Show more ({n} left)",
  "players": "Players",
  "searchThing": "Search {thing}",
  "clearShown": "Clear shown",
  "selectAllShown": "Select all shown ({n})",
  "noPlayerMatch": "No player matches.",
  "noPlayers": "No players."
};
const ar: typeof en = {
  "leaveOut": "استبعاده",
  "leftOut": "أُزيل من {name}",
  "moreWarnings": "(ولا مزيد) | (ومثلها واحدة أخرى) | (ومثلها اثنتان أخريان) | (ومثلها {n} أخرى) | (ومثلها {n} أخرى) | (ومثلها {n} أخرى)",
  "nOnline": "{n} متصل",
  "nOffline": "{n} غير متصل",
  "titleTarget": "إضافة إلى قائمة التشغيل · {name}",
  "titleOne": "نشر «{name}»",
  "titleMany": "نشر {n} عنصر",
  "alreadyInList": "موجود بالفعل في هذه القائمة",
  "alreadyOnPlayer": "موجود بالفعل على هذا المشغل",
  "alreadyInGroup": "موجود بالفعل في هذه المجموعة",
  "onAllTargets": "موجود بالفعل عليها كلها",
  "onNOfM": "على {n} من {m}",
  "skipped": " · {n} موجود بالفعل، تم تخطيه",
  "publishedTo": "تم النشر على {players}{skipped}",
  "nothingNew": "لا جديد للنشر{skipped}",
  "nPlayers": "لا مشغلات | مشغل واحد | مشغلان | {n} مشغلات | {n} مشغلًا | {n} مشغل",
  "more": "+{n} أخرى",
  "searchContent": "البحث في المحتوى",
  "searchTargets": "ابحث في المشغلات والمجموعات والوسوم",
  "search": "بحث",
  "loading": "جارٍ التحميل…",
  "allPlayers": "النشر على كل المشغلات",
  "groups": "مجموعات المشغلات",
  "nSelected": "{n} محدد",
  "playOrder": "ترتيب التشغيل",
  "playOrderHint": "تُعرض بهذا الترتيب، واحدًا تلو الآخر. اسحب صفًا، أو استخدم ↑ ↓، لتغييره.",
  "dragOrder": "إعادة ترتيب {name}، رقم {n}: اسحب، أو Alt+↑ / Alt+↓",
  "dragOrderTip": "اسحب لإعادة الترتيب",
  "playsNth": "يُعرض {n}",
  "moveUp": "تحريك {name} لأعلى",
  "moveDown": "تحريك {name} لأسفل",
  "unpick": "إزالة {name} من التحديد",
  "noGroups": "لا توجد مجموعات مشغلات.",
  "tags": "الوسوم",
  "addTag": "+ إضافة وسم",
  "addTagSr": "إضافة وسم",
  "tagsHint": "سيُنشر المحتوى على كل المشغلات والمجموعات التي تحمل هذه الوسوم — وكذلك ما يُوسم لاحقًا.",
  "where": "الموضع في القائمة",
  "atEnd": "في النهاية",
  "atStart": "في البداية",
  "atEndHint": "يُعرض بعد المحتوى الحالي",
  "atStartHint": "يُعرض أولًا قبل الباقي",
  "reach": "← {players}",
  "plusFuture": " الآن (+ ما يُوسم لاحقًا)",
  "cancel": "إلغاء",
  "publishing": "جارٍ النشر…",
  "publish": "نشر",
  "tAll": "الكل",
  "tPlaylists": "قوائم التشغيل",
  "tCampaigns": "الحملات",
  "tApps": "التطبيقات",
  "tVideos": "الفيديوهات",
  "tImages": "الصور",
  "contentType": "نوع المحتوى",
  "clear": "مسح",
  "nothingMatches": "لا توجد نتائج مطابقة.",
  "newContent": "جديد",
  "newUpload": "رفع ملفات",
  "newUploadHint": "تُضاف هنا وتُحدَّد عند جاهزيتها",
  "newWebPage": "صفحة ويب",
  "newApp": "تطبيق (ساعة، طقس، شريط أخبار…)",
  "newComposition": "تكوين",
  "readyPublishQ": "«{name}» جاهز",
  "createdPublishQ": "تم حفظ «{name}»",
  "publishNow": "انشر الآن",
  "newPlaylist": "قائمة تشغيل",
  "newCampaign": "حملة",
  "newEditorHint": "يفتح المحرر ثم يعود إلى هنا",
  "uploadingN": "جارٍ رفع {n}…",
  "optimizing": "جارٍ التحسين… {p}",
  "waitUploads": "بانتظار انتهاء الرفع",
  "uploadFailed": "فشل الرفع: {error}",
  "intentBanner": "إنشاء لـ «{name}»: احفظه للعودة والنشر",
  "showMore": "عرض المزيد (متبقٍ {n})",
  "players": "المشغلات",
  "searchThing": "البحث في {thing}",
  "clearShown": "مسح المعروض",
  "selectAllShown": "تحديد كل المعروض ({n})",
  "noPlayerMatch": "لا يوجد مشغل مطابق.",
  "noPlayers": "لا توجد مشغلات."
};
export default { en, ar };
